import React from 'react';

const control =
  'w-full rounded-lg border border-line bg-surface text-sm text-ink placeholder:text-ink-subtle ' +
  'transition-colors duration-150 hover:border-line-strong focus:border-brand focus:outline-none ' +
  'focus:ring-2 focus:ring-brand/20 disabled:bg-surface-subtle disabled:text-ink-subtle';

export const Input = React.forwardRef(function Input({ className = '', icon, ...props }, ref) {
  if (icon) {
    return (
      <div className="relative">
        <span className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3 text-ink-subtle">
          {icon}
        </span>
        <input ref={ref} className={`${control} h-9 ps-9 pe-3 ${className}`} {...props} />
      </div>
    );
  }
  return <input ref={ref} className={`${control} h-9 px-3 ${className}`} {...props} />;
});

export const Select = React.forwardRef(function Select({ className = '', children, ...props }, ref) {
  return (
    <select ref={ref} className={`${control} h-9 px-3 ${className}`} {...props}>
      {children}
    </select>
  );
});

export const Checkbox = React.forwardRef(function Checkbox({ className = '', ...props }, ref) {
  return (
    <input
      ref={ref}
      type="checkbox"
      className={`h-4 w-4 cursor-pointer rounded border-line-strong text-brand focus:ring-brand/30 ${className}`}
      {...props}
    />
  );
});

export const Label = ({ children, className = '', ...props }) => (
  <label className={`mb-1 block text-xs font-medium text-ink-muted ${className}`} {...props}>
    {children}
  </label>
);
